import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-wf-mine",
  "use": "icon-soc-wf-mine-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-wf-mine\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"256\" width=\"640\" height=\"576\" rx=\"40\" /><path d=\"M192 256h640v128H192z\" /><path d=\"M320 192h64v128h-64zM640 192h64v128h-64z\" /><circle cx=\"352\" cy=\"320\" r=\"56\" fill=\"#fff\" /><path d=\"M256 544h448v96H256z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-wf-mine.svg
// module id = 8bNl
// module chunks = 534